import dayjs from 'dayjs';
import React from 'react';
import { StackedBarChart } from '@carbon/charts-react';
import { useChartTheme } from './useChartTheme';

interface BucketedBarChartProps {
  title: string;
  dateFormat: string;
  data: Array<{ bucketKey: string; group: string; value: number }>;
}

/**
 * The bucketed trend chart, stacked by group — total volume per bucket plus its composition
 * (e.g. issues per day, stacked by type). `bucketKey` is the server's already-timezone-correct
 * bucket label, so this component formats it for display and never recomputes a boundary.
 */
const BucketedBarChart = React.memo((props: BucketedBarChartProps) => {
  const chartTheme = useChartTheme();
  return (
    <div className="dashboard__stat_widget">
      <StackedBarChart
        data={props.data.map((row) => ({ group: row.group, date: row.bucketKey, value: row.value ?? 0 }))}
        options={{
          title: props.title,
          axes: {
            left: { mapsTo: 'value' },
            bottom: {
              mapsTo: 'date',
              scaleType: 'time' as any,
              ticks: { formatter: (date) => dayjs(date).format(props.dateFormat) },
            },
          },
          experimental: true,
          height: '400px',
          zoomBar: {
            top: {
              enabled: true,
              type: 'slider_view' as any,
              initialZoomDomain:
                props.dateFormat === 'MM/YYYY'
                  ? [dayjs().subtract(7, 'month').toDate(), dayjs().add(1, 'month').toDate()]
                  : [dayjs().subtract(7, 'day').toDate(), dayjs().add(1, 'day').toDate()],
            },
          },
          theme: chartTheme,
        }}
      />
    </div>
  );
});

export default BucketedBarChart;
